// User Invitation API
import api, { type AxiosResponse } from './client';
import type {
  UserInvitation,
  UserInvitationCreate,
  InvitationAccept,
  InvitationValidation,
  User,
  QueryParams,
} from './types';

export const invitationAPI = {
  // List invitations
  getInvitations: (params?: QueryParams): Promise<AxiosResponse<{ count: number; results: UserInvitation[] }>> =>
    api.get('/core/invitations/', { params }),

  // Get single invitation
  getInvitation: (id: number): Promise<AxiosResponse<UserInvitation>> =>
    api.get(`/core/invitations/${id}/`),

  // Create invitation
  createInvitation: (data: UserInvitationCreate): Promise<AxiosResponse<UserInvitation>> =>
    api.post('/core/invitations/', data),

  // Resend invitation
  resendInvitation: (id: number): Promise<AxiosResponse<{ message: string; invitation: UserInvitation }>> =>
    api.post(`/core/invitations/${id}/resend/`),

  // Cancel invitation
  cancelInvitation: (id: number): Promise<AxiosResponse<{ message: string; invitation: UserInvitation }>> =>
    api.post(`/core/invitations/${id}/cancel/`),

  // Validate invitation token (public)
  validateToken: (token: string): Promise<AxiosResponse<InvitationValidation>> =>
    api.get('/core/invitations/validate/', { params: { token } }),

  // Accept invitation (public)
  acceptInvitation: (data: InvitationAccept): Promise<AxiosResponse<{ message: string; user: User; token: string }>> =>
    api.post('/core/invitations/accept/', data),
};
